import React, { useEffect } from "react";
import { TgkDropDownSource } from "../../interfaces/CoObject";
import { DropDownGrid } from "./DropDownGrid";
import { ObjectPanelTabs } from "../co-panel/ObjectPanelComponent";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { TgkDropDownItem } from "../../../api/models/tgk-dropdown-item";

interface ResultCheck {
  dataToUpdate?: TgkDropDownItem[];
  isValid?: boolean;
}

function checkValidItem(data: TgkDropDownItem[]): ResultCheck {
  let isValid = true;

  const results = data.map((myItem) => {
    let item: TgkDropDownItem = myItem;

    item.keyError = undefined; //no error
    item.key = item.key?.toString();

    item.valueError = undefined; //no error
    item.value = item.value?.toString();

    if (item.value == null || item.value.length < 1) {
      isValid = false;
      item.valueError = formatMessage(`cof.objectsource.dropdown.message.warning.valuerequired`);
    }
    if (item.key == null || item.key.length < 1) {
      isValid = false;
      item.keyError = formatMessage(`cof.objectsource.dropdown.message.warning.displaynamerequired`);
    }

    data
      .filter((d) => item.itemId != d.itemId)
      .forEach((element) => {
        if (item.key == null || element?.key?.toString() === item.key) {
          item.keyError =
            item.keyError ?? formatMessage(`cof.objectsource.dropdown.message.warning.displaynameduplicated`);
          isValid = false;
        }
        if (item.value == null || element?.value?.toString() === item.value) {
          item.valueError =
            item.valueError ?? formatMessage(`cof.objectsource.dropdown.message.warning.valueduplicated`);
          isValid = false;
        }
      });
    return item;
  });
  return { dataToUpdate: results, isValid: isValid };
}

interface CoObjectSourceTableProps {
  objectSource: TgkDropDownSource;
  updateCoObjectSourceDropDown: (obj: TgkDropDownSource, tabValid, modified: boolean) => void;
  isLocked: boolean;
  tab: ObjectPanelTabs;
}

const defaultItems = [
  { inEdit: true, itemId: 1, key: null, value: null },
  { inEdit: true, itemId: 2, key: null, value: null },
];

export const CoObjectSourceDropDownPanel: React.FunctionComponent<CoObjectSourceTableProps> = (props) => {
  const { objectSource, updateCoObjectSourceDropDown, isLocked } = props;

  useEffect(() => {
    const objSource =
      objectSource == null
        ? ({
            type: "DROPDOWN_LIST",
            dropDownList: defaultItems,
          } as TgkDropDownSource)
        : ({
            ...objectSource,
            type: "DROPDOWN_LIST",
            dropDownList: objectSource.dropDownList
              ? objectSource.dropDownList.map((item) => ({ ...item, inEdit: true }))
              : defaultItems,
          } as TgkDropDownSource);
    updateCoObjectSourceDropDown(objSource, validateFields(objSource), false);
  }, []);

  function setDropDownList(dropDownList) {
    const obj = {
      ...objectSource,
      type: "DROPDOWN_LIST",
      dropDownList: dropDownList,
    } as TgkDropDownSource;
    updateCoObjectSourceDropDown(obj, validateFields(obj), true);
  }

  function validateFields(source: TgkDropDownSource): ObjectPanelTabs {
    let resultCheck: ResultCheck = {};

    if (!source?.dropDownList || source.dropDownList.length < 2) resultCheck.isValid = false;
    else resultCheck = checkValidItem(source.dropDownList);

    return { key: props.tab.key, name: props.tab.name, isValid: resultCheck.isValid };
  }

  return (
    <DropDownGrid
      isLocked={isLocked}
      setGridData={setDropDownList}
      gridData={objectSource ? objectSource.dropDownList : []}
    />
  );
};
